function maskCep(value: string) {
  value = value.replace(/\D/g, "").replace(/^(\d{2})(\d{3})(\d{3})$/, "$1.$2-$3")
  return value;
}

function limparCEP(cep: string) {
  return cep.replace(/\D/g, '');
}

function maskCpf(value: string) {
  value = value.replace(/\D/g, "");
  value = value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
  return value;
}

function maskCnpj(value: string) {
  value = value.replace(/\D/g, "");
  value = value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
  return value;
}

function maskCpfCnpj(value: string) {
  value = `${value}`.replace(/[^\d]/g, '');

  if (value.length <= 11) {
    return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  } else {
    return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }
}

const removeMask = (value: string) => {
  return value.replace(/[^\d]+/g, ''); // Remove tudo que não é número
};


function maskPhone(value: string) {
  value = value.replace(/\D/g, "");
  value = value.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3");
  return value;
}

function maskCurrency(value: string) {
  value = value.replace(/[^\d0]/g, "")
  value = value.replace(/\D/g, "");
  value = value.replace(/(\d)(\d{2})$/, "$1,$2");
  value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");
  return value;
}

const maskBRL = (value: number | undefined): string => {
  if (value === undefined) return 'R$ 0,00';
  if (value === null) return 'R$ 0,00';
  const options = {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  };

  return value.toLocaleString('pt-BR', options);
}

function maskPrice(value: string) {
  value = value.replace(/\D/g, "");
  value = value.replace(/(\d)(\d{2})$/, "$1.$2");
  return value;
}

function maskNumber(value: string) {
  value = value.replace(/\D/g, "").replace(/(\d{2})$/, "$1")
  return value;
}

// export const maskMoney = (value: string) => {
//   value = value.replace(/\D/g, "");
//   value = value.replace(/(\d)(\d{2})$/, "$1.$2");
//   return value;
// }

export const maskMoney = (value: number | string) => {
  value = value.toString().replace(/\D/g, '');
  const cleanedValue = value.replace(/\D/g, '');

  // Converte para número e divide por 100 para ajustar os centavos
  const numericValue = parseFloat(cleanedValue) / 100;

  // Formata para o padrão brasileiro de moeda
  if (isNaN(numericValue)) {
    return 'R$ 0,00'
  } else {
    return numericValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

}

export const unmaskMoney = (value: string): number => {
  if (!value) return 0;
  let v = value.replace(/[^\d,.-]/g, "");
  if (v.includes(",")) {
    v = v.replace(/\./g, "").replace(",", ".");
  }
  const num = parseFloat(v);
  return isNaN(num) ? 0 : num;
};


const maskPhone2 = (value: string) => {
  if (value) {
    // Remove qualquer caractere não numérico
    value = value.replace(/\D/g, '');

    // Máscara de telefone fixo: (##) ####-####
    if (value.length <= 10) {
      value = value
        .replace(/(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{4})(\d)/, '$1-$2');
    }
    // Máscara de celular: (##) #####-####
    else {
      value = value
        .replace(/(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{5})(\d)/, '$1-$2');
    }

    return value;

  } else {
    return ''
  }
};

const capitalizeFirstLetter = (str: string) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

function maskArea(value: string) {
  value = value.replace(/\D/g, ""); // Remove tudo que não for número
  if (value) {
    return `${value} m²`;
  }
  return '';
}



export { maskCep, limparCEP, maskCpf, maskCnpj, maskPhone, maskCurrency, maskPrice, maskNumber, maskBRL, maskPhone2, maskCpfCnpj, removeMask, capitalizeFirstLetter, maskArea };